import { CommonStoreKey } from './reducer';

export const SelectSearchValInStore = (state, val) => state[CommonStoreKey][val];
